import { render } from "./ContactManagement-page.vue?vue&type=template&id=2affe238&scoped=true"
import script from "./ContactManagement-page.vue?vue&type=script&lang=js"
export * from "./ContactManagement-page.vue?vue&type=script&lang=js"

import "./ContactManagement-page.vue?vue&type=style&index=0&id=2affe238&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2affe238"]])

export default __exports__